<ng-container>
  <div class="col-lg-12 float-left p-3 border">
    <div class="w-100">
      <div class="w-100 customersearch-title">
        {{ 'customer.recentCustomer.heading' | cxTranslate }}
      </div>
    </div>
    @if (customerResult$ | async; as customerResult) {
      <div class="col-lg-12 customer-search bg-white p-0 float-left">
        @if (customerResult && customerResult.length) {
          <div
            class="customersearch-list-table mt-3 float-left col-lg-12 p-0"
            >
            <div class="customersearch-list-titles border-top border-bottom float-left w-100 pl-2 pr-2 pt-3 pb-3">
              <div class="col-7 pl-1 padding-res-0 float-left font-text-600">
                {{ 'customer.recentCustomer.name' | cxTranslate }}
              </div>
              <div class="col-3 float-left font-text-600">{{ 'customer.recentCustomer.city' | cxTranslate }}</div>
              <div class="col-2 float-left font-text-600">{{ 'customer.recentCustomer.state' | cxTranslate }}</div>
            </div>
            @for (customer of customerResult; track customer) {
              <div
                class="bg-white customersearch-list-titles table-content border-bottom float-left w-100 p-2 font-weight-normal d-flex align-items-center"
                (click)="storeInContext(customer)"
                >
                <div class="col-7 pl-1 title-wrap padding-res-0 float-left">
                  <span class="res-titles">{{ 'customer.label.name' | cxTranslate }}:</span >{{ customer.customerNumber | removeLeadingZeros }} - {{ customer.customerName }}
                </div>
                <div class="col-3 title-wrap float-left">
                  <span class="res-titles">{{ 'customer.label.city' | cxTranslate }}:</span>{{ customer.city }}
                </div>
                <div class="col-2 title-wrap float-left">
                  <span class="res-titles">{{ 'customer.label.state' | cxTranslate }}:</span>{{ customer.state ? formatState(customer.state) : '-' }}
                </div>
              </div>
            }
          </div>
        }
        @if (customerResult && customerResult.length < 1) {
          <div class="alert-info p-3 rounded mt-3">
            {{ 'customer.label.noCustomerFound' | cxTranslate }}
          </div>
        }
      </div>
    }
  </div>
</ng-container>
@if (!(customerResult$ | async)) {
  <cx-spinner></cx-spinner>
}
